import type { LookupService } from "@izohek/warno-deck-utils";
import type { UnitMap } from "../types/deck-builder";
import type { Division } from "../types/deck-builder";

export class LookupAdapter implements LookupService {
  protected units: Array<{ id: number | undefined; descriptorName: string }>;
  protected divisions: Division[];

  constructor(units: UnitMap, divisions: Division[]) {
    this.units = Object.values(units);
    this.divisions = divisions;
  }

  public largestUnitId(): number {
    const maxId = this.units.reduce(
      (accumulator, currentValue) => {
        const id = currentValue.id ?? 0;
        return Math.max(id, accumulator);
      },
      0
    );
    return maxId;
  }

  public unitForId(id: number): string | undefined {
    const unit = this.units.find((u) => u.id === id);
    const result = unit?.descriptorName;
    if (!result) {
      console.warn("[LookupAdapter.unitForId] Unit not found for ID:", {
        id,
        availableIds: this.units.filter(u => u.id !== undefined).map(u => u.id).slice(0, 10),
      });
    }
    return result;
  }

  public divisionForId(id: number): string | undefined {
    const division = this.divisions.find((d) => d.id === id);
    const result = division?.descriptor;
    if (!result) {
      console.warn("[LookupAdapter.divisionForId] Division not found for ID:", {
        id,
        availableIds: this.divisions.map(d => ({ id: d.id, descriptor: d.descriptor })).slice(0, 10),
      });
    }
    return result;
  }
}

